var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.528,
    height: 16.959,
    viewBox: "0 0 17.528 16.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_214965",
    "data-name": "Path 214965",
    d: "M26.8,27.226v1.165a3.647,3.647,0,0,1-3.7,3.588H17.824a3.647,3.647,0,0,1-3.7-3.588V18.909a3.647,3.647,0,0,1,3.7-3.588H23.1a3.647,3.647,0,0,1,3.7,3.588v1.03a.841.841,0,1,1-1.681,0v-1.03A1.965,1.965,0,0,0,23.1,17H17.824a1.965,1.965,0,0,0-2.015,1.907v9.482A1.965,1.965,0,0,0,17.824,30.3H23.1a1.965,1.965,0,0,0,2.015-1.907V27.226a.841.841,0,1,1,1.681,0Zm4.32-4.157-2.2-2.289a.841.841,0,0,0-1.213,1.164l.831.865H22.865a.841.841,0,1,0,0,1.681h5.581l-.716.7a.842.842,0,0,0,.586,1.443.822.822,0,0,0,.588-.24l2.2-2.137a.837.837,0,0,0,.019-1.184Z",
    transform: "translate(-13.978 -15.171)",
    fill: "#383838",
    stroke: "#fff",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.b9a7670068a8fbccac8b3aa49711ebb4.svg";
export { ForwardRef as ReactComponent };